<dialog
  #dialog
  qai-dialog
  [heading]="modalHeading"
  (closeButtonClicked)="onCancel()"
>
  <p class="modal-description">{{ 'simulationBuilder.DIALOG_DESCRIPTION_ADD_USERS' | transloco }}</p>

  <div class="users-section">
    <div class="users-header">
      <span class="users-heading">{{ 'simulationBuilder.CONFIRMATION_SELECTED_USERS_HEADING' | transloco }}</span>
      <span class="users-count">{{ 'simulationBuilder.CONFIRMATION_TOTAL_COUNT' | transloco: { count: selectedUsers.length } }}</span>
    </div>

    <qai-table
      [headers]="headers"
      [data]="tableData"
      [striped]="false"
      [pageSize]="pageSize"
      [showPagination]="true"
      [currentPage]="currentPage"
      [noDataMessage]="'simulationBuilder.NO_USERS_SELECTED' | transloco"
      [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
      [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
      (pageChanged)="onPageChanged($event)"
      (cellClick)="onCellClick($event)"
    ></qai-table>
  </div>

  <div class="action-button-container">
    <button qai-button kind="secondary" size="medium" (click)="onBack()">
      {{ 'simulationBuilder.BUTTON_BACK' | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      size="medium"
      [disabled]="networkRequestInProgress || selectedUsers.length === 0"
      (click)="onConfirm()"
    >
      {{ confirmButtonText }}
    </button>
  </div>
</dialog>
